import Breadcrumb from '../components/Breadcrumb';
import HeaderFooterLayout from "../components/layouts/HeaderFooterLayout"
import styles from "./PrivacyPolicy.module.css"
import { useEffect } from "react";

const PrivacyPolicy = () => {

    useEffect(() => {
        const script = document.createElement("script");
        script.id = "CookieDeclaration";
        script.src =
            "https://consent.cookiebot.com/ebce4f9a-5b8a-4280-9cec-5ec2c77fe230/cd.js";
        script.type = "text/javascript";
        script.async = true;
        const content = document.querySelector('#privacy-content')
        content.appendChild(script);

        const moveCookieDeclaration = () => {
            try {
                const cookieDeclaration = document.querySelector('.CookieDeclaration');
                if (cookieDeclaration && !content.contains(cookieDeclaration)) {
                    content.appendChild(cookieDeclaration);
                }
                moveCookieError();
            }
            catch (error) {
                console.error("Error moving Cookie Declaration:", error);
            }
        };

        const moveCookieError = () => {
            try {
                const parent = document.getElementById('app-content');
                if (parent) {
                    const divWithoutClassContainingError = Array.from(parent.querySelectorAll('div')).find(div =>
                        (!div.className || div.className.trim() === "") && // Verifica che la div non abbia una classe
                        Array.from(div.childNodes).some(node =>
                            node.nodeType === Node.TEXT_NODE && node.nodeValue.includes('Error:') // Verifica che contenga direttamente il testo "Error:"
                        )
                    );
                    if (divWithoutClassContainingError) {
                        const errorText = divWithoutClassContainingError.innerHTML;
                        divWithoutClassContainingError.remove();
                        content.innerHTML = `<div class="${styles.errorText}">${errorText}</div>` + content.innerHTML;
                    }
                }
            }
            catch (error) {
                console.error("Error moving text:", error);
            }
        }

        const observer = new MutationObserver(moveCookieDeclaration);
        observer.observe(document.body, { childList: true, subtree: true });

        return () => {
            // content.removeChild(script);
            observer.disconnect();
        };

    }, []);

    return (
        <HeaderFooterLayout contentStyle={{ backgroundColor: "var(--background-secondary-color)" }}>
            <div className={styles.container}>
                <div className={styles.section}>
                    <div className={styles.sectionInner}>
                        <Breadcrumb items={[{ label: 'Home', to: '/' }, { label: 'Privacy Policy' }]} />
                        <header className={styles.header}><h1>Privacy Policy</h1><p>Informative sul trattamento dei dati personali, diritti e utilizzo dei cookie.</p></header>
                        <div className={styles.layout}>
                        <nav className={styles.index} aria-label="Indice della privacy policy"><span>In questa pagina</span><a href="#protezione-dati">Protezione dei dati</a><a href="#trattamento-dati">Trattamento e informative</a><a href="#diritti">I tuoi diritti</a><a href="#approfondimenti">Approfondimenti</a><a href="#cookie-policy">Cookie Policy</a></nav>
                        <div className={styles.document}>
                        <div className={styles.privacyPolicy}>
                            <section id="protezione-dati" className={styles.documentCard}>
                                <h2 className={styles.title}>Per noi la protezione dei dati personali è importante</h2>
                                <div className={styles.body}>
                                    In questa sezione troverà informazioni e indicazioni sempre aggiornate e utili su come trattiamo i dati personali e come esercitare i diritti.
                                </div>
                                <div className={styles.headline}>Titolare del trattamento:</div>
                                <div className={styles.body}>
                                    Starting Finance S.r.l. - Via F. Patrizio da Cherso 30, 00143 - Roma (RM), <a href="mailto:amministrazione@startingfinance.com">amministrazione@startingfinance.com</a> (di seguito “Titolare” o "Starting Finance")
                                </div>

                                <div className={styles.headline}>Responsabile della protezione dei dati:</div>
                                <div className={styles.body}>
                                    <a href="mailto:dpo@datagovernance.digital">dpo@datagovernance.digital</a> (di seguito “DPO”)
                                </div>
                            </section>

                            <section id="trattamento-dati" className={styles.documentCard}>
                                <h2 className={styles.title}>Come trattiamo i dati personali</h2>
                                <div className={styles.body}>
                                    A partire dal 25 maggio 2018 ha trovato piena applicazione il nuovo Regolamento (UE) 2016/679 sulla protezione dei dati personali (di seguito “Regolamento”), contiene una serie di norme dirette a garantire che il trattamento dei dati personali avvenga nel rispetto dei diritti e delle libertà fondamentali delle persone.
                                    <br />
                                    <br />
                                    Proseguendo troverà pubblicate le nostre informative sul trattamento dei dati personali:
                                    <ul>
                                        <li><a rel="noreferrer" target="_blank" href="/terms-and-conditions">Condizioni d'uso e di vendita</a>: informativa </li>
                                        <li><a rel="noreferrer" target="_blank" href="/privacy-policy/informativa-sito-web">Informativa Sito web e Piattaforma</a>: informativa specifica che descrive il trattamento dei dati personali nell’ambito della gestione del sito web, piattaforma e pagine social;</li>
                                        <li><a rel="noreferrer" target="_blank" href="/privacy-policy/informativa-generale">Informativa Generale</a>: in cui forniamo informazioni sui dati trattati, sulle finalità e modalità del trattamento, sui diritti esercitabili e sui tempi di conservazione dei dati;</li>
                                        <li><a rel="noreferrer" target="_blank" href="https://starting-finance-dev.fra1.cdn.digitaloceanspaces.com/documents/Informativa_lead_Aircall_SF_v1.5(solo%20informativa).pdf">Informativa Contatti commerciali e registrazione delle chiamate</a>: informativa specifica sul trattamento dei dati personali nell'ambito dei contatti commerciali e della registrazione delle chiamate.</li>
                                        <li><a rel="noreferrer" target="_blank" href="https://starting-finance-dev.fra1.cdn.digitaloceanspaces.com/documents/SF_Liberatoria_audiovisivo_v2.pdf">Informativa Consenso Video</a>: informativa specifica che descrive il trattamento dei suoi dati personali per la gestione delle videolezioni, delle registrazioni audio/video associate e del materiale audiovisivo degli eventi online e in presenza.</li>
                                        <li><a rel="noreferrer" target="_blank" href="https://starting-finance-dev.fra1.cdn.digitaloceanspaces.com/documents/informativa-evento.pdf">Informativa Eventi</a>: informativa specifica che descrive il trattamento dei dati personali relativi alla partecipazione agli eventi online e in presenza.</li>
                                        <li><a rel="noreferrer" target="_blank" href="https://starting-finance-dev.fra1.cdn.digitaloceanspaces.com/documents/Viaggi%20formativi_Cancellazione_Politica.docx%20(1).pdf">Informativa Viaggi Formativi</a>: informativa specifica che descrive il trattamento dei dati personali relativi alla partecipazione ai viaggi formativi e le condizioni d'uso e cancellazione.</li>
                                    </ul>
                                </div>
                            </section>

                            <section id="diritti" className={styles.documentCard}>
                                <h2 className={styles.title}>Come esercitare i diritti</h2>
                                <div className={styles.body}>
                                    L’interessato ha il diritto di ottenere dal Titolare del trattamento, nei casi previsti, l’accesso ai dati personali e la rettifica o la cancellazione degli stessi o la limitazione del trattamento che lo riguarda o di opporsi al trattamento (artt. 15 e ss. del Regolamento). L’apposita istanza al Titolare del trattamento è presentata contattando l’e-mail preposta per il riscontro all’interessato o compilando il modulo disponibile nell’area privacy dedicata.
                                </div>

                                <div className={styles.headline}>Modalità di esercizio dei diritti:</div>
                                <div className={styles.body}>
                                    Per l’esercizio dei suoi diritti può inviare una comunicazione all'e-mail: <a href="mailto:amministrazione@startingfinance.com">amministrazione@startingfinance.com</a><br></br>
                                    Inoltre, può contattare il Responsabile della protezione dei dati - DPO all'e-mail:  <a href="mailto:dpo@datagovernance.digital">dpo@datagovernance.digital</a>
                                    <br />
                                    <br />
                                    Diritto di reclamo: l’interessato qualora ritenga che il trattamento dei dati personali a lui riferiti avvenga in violazione di quanto previsto dal Regolamento, ha il diritto di proporre reclamo all’<a target="_blank" rel="noreferrer" href="https://www.gpdp.it">Autorità Garante per la Protezione dei Dati Personali</a> italiana, come previsto dall’art. 77 del Regolamento, o di adire alle opportune sedi giudiziarie (art. 79 del Regolamento).
                                </div>
                            </section>
                            <section id="approfondimenti" className={styles.documentCard}>
                                <h2 className={styles.title}>Per saperne di più</h2>
                                <div className={styles.body}>
                                    <ul>
                                        <li><a target="_blank" rel="noreferrer" href="https://www.garanteprivacy.it/codice">Testo completo al Decreto legislativo 30 giugno 2003 n.196 - Codice Privacy</a></li>
                                        <li><a target="_blank" rel="noreferrer" href="https://eur-lex.europa.eu/legal-content/IT/TXT/?uri=CELEX:32016R0679">Testo completo del Regolamento europeo del 27 aprile 2016 n. 679</a></li>
                                    </ul>
                                </div>
                            </section>
                        </div>
                        <section id="cookie-policy" className={styles.documentCard}>
                            <h2 className={styles.title}>Cookie Policy</h2>
                            <div id="privacy-content" className={styles.cookies}></div>
                        </section>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </HeaderFooterLayout>
    )

}

export default PrivacyPolicy
